<div class="relative px-4">
  <proffeo-ui-input
    [(value)]="search"
    variant="search"
    placeholder="placeholders.search-input"
  />
</div>

<div class="flex-grow h-full">
  <div class="flex items-center mt-2">
    <div class="w-full flex items-center border-b border-proffeo-surface-off">
      <div class="flex items-center">
        <mat-checkbox
          (change)="onSelectAllChange($event)"
          [checked]="allSelected()"
        >
          {{ 'placeholders.select-all' | translate }}
        </mat-checkbox>
      </div>
    </div>
  </div>

  @for (user of filteredUsers(); track user?.id; let isLast = $last) {
    <div class="flex items-center">
      <div
        [ngClass]="isLast ? '' : 'border-b border-proffeo-surface-off'"
        class="flex flex-column items-center w-full py-1 border-b border-proffeo-overlay-subtle bg-proffeo-surface-muted"
      >
        <div class="flex items-center justify-center shrink-0 self-center">
          <mat-checkbox
            (change)="onUserCheckboxChange($event, user)"
            [checked]="isSelected(user.id)"
            [disabled]="isLocked(user.id)"
          ></mat-checkbox>
        </div>
        <proffeo-avatar
          [user]="user"
          [size]="AvatarSize.SM"
        />
        <div class="flex flex-col ml-2 py-2 w-full truncate">
          <p>{{ user?.firstName }} {{ user?.lastName }}</p>
          <!--            @if (permissionContext) {-->

          <!--              <app-user-role-display-->
          <!--                [context]="permissionContext"-->
          <!--                [userId]="user.id">-->
          <!--              </app-user-role-display>-->

          <!--            }-->
        </div>
      </div>
    </div>
  }
</div>
